'use strict';
define('elements/object-fit',['object-fit'], function(objectFit) {
	objectFit.polyfill({
		selector: '.accordion__plate-content img',
		fittype: 'cover',
		disableCrossDomain: 'true'
	});
	objectFit.polyfill({
		selector: '.footer__partner img',
		fittype: 'contain',
		disableCrossDomain: 'true'
	});
	objectFit.polyfill({
		selector: '.gallery__item img',
		fittype: 'cover',
		disableCrossDomain: 'true'
	});
	objectFit.polyfill({
		selector: '.guide__picture img',
		fittype: 'cover',
		disableCrossDomain: 'true'
	});
	objectFit.polyfill({
		selector: '.guide__picture--big img',
		fittype: 'cover',
		disableCrossDomain: 'true'
	});
	objectFit.polyfill({
		selector: '.guide-teaser__profile img',
		fittype: 'cover',
		disableCrossDomain: 'true'
	});
	objectFit.polyfill({
		selector: '.header__image img',
		fittype: 'cover',
		disableCrossDomain: 'true'
	});
	objectFit.polyfill({
		selector: '.trip-teaser__image img',
		fittype: 'cover',
		disableCrossDomain: 'true'
	});
	objectFit.polyfill({
		selector: '.trip-teaser__profile img',
		fittype: 'cover',
		disableCrossDomain: 'true'
	});
});
